import type { ReactElement } from "react";
import type { NewbornGuide } from "../types";
import { findResourceArticleByHref, formatResourcePublishedAt } from "../data/resourceArticles";
import { UiIcon } from "./UiIcons";

interface NewbornGuideCardProps {
  guide: NewbornGuide;
}

export const NewbornGuideCard = ({ guide }: NewbornGuideCardProps): ReactElement => {
  const article = findResourceArticleByHref(guide.href);

  return <a className="newborn-guide-card" href={guide.href}>
    {guide.imageSrc ? (
      <span className="newborn-guide-card__image">
        <img alt={guide.imageAlt || `${guide.title} guide cover`} loading="lazy" src={guide.imageSrc} />
      </span>
    ) : (
      <span aria-hidden="true" className={`newborn-image-placeholder newborn-image-placeholder--${guide.tone}`} />
    )}
    <span className="newborn-guide-card__body">
      {(guide.eyebrow || article?.eyebrow) && (
        <span className="newborn-guide-card__eyebrow">{guide.eyebrow || article?.eyebrow}</span>
      )}
      <strong>{guide.title}</strong>
      <span>{guide.description}</span>
      {article && (
        <time className="newborn-guide-card__meta" dateTime={article.publishedAt}>
          {formatResourcePublishedAt(article.publishedAt)} · {article.readTime}
        </time>
      )}
      <small>
        Read guide <UiIcon name="arrow" />
      </small>
    </span>
  </a>;
};
